import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateUser = async (payload) => {
  try {
    const response = await APIs.post('/create_admin', payload);

    if (response?.data?.message === 'success') {
      toast('Registered Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllAdminDetails = async (payload) => {
  try {
    const response = await APIs.get(
      `/admin_get_all_registered_users/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteAdmin = async (payload) => {
  try {
    const response = await APIs.post(`/admin_delete_user`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadProfileImage = async (payload) => {
  try {
    const response = await APIs.post(`/cloudinary_file_upload`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editUserFromAdmin = async (payload) => {
  try {
    const response = await APIs.patch(`/admin_edit_user`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const UserServices = {
  CreateUser,
  getAllAdminDetails,
  DeleteAdmin,
  uploadProfileImage,
  editUserFromAdmin,
};

export default UserServices;
